import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import React from 'react';

export interface InvitedFriend {
  key: string;
  name: string;
  email: string;
  updatedAt: string;
}

const columns: ColumnsType<InvitedFriend> = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (name: string) => (
      <div className='flex font-medium'>
        <span className='whitespace-nowrap'>{name}</span>
      </div>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (email: string) => (
      <div className='flex font-medium'>
        <span>{email}</span>
      </div>
    ),
  },
  {
    title: <div className='whitespace-nowrap'>Invited Date</div>,
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: (joinDate: string) => (
      <div className='flex font-medium whitespace-nowrap'>
        <span>{moment(joinDate).format('DD MMM YYYY')}</span>
      </div>
    ),
  },
];

const rowClassName = (_: any, index: number) => {
  return index % 2 === 0 ? 'bg-cartBgColor' : 'bg-[#282829]';
};
const FriendInvited: React.FC<{
  data: InvitedFriend[];
  loading: boolean;
}> = ({ data, loading }) => {
  return (
    <div>
      <h2 style={{ color: '#fff' }} className='pb-5 text-2xl font-semibold'>
        Friends Invited
      </h2>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        className='rounded-xl overflow-x-auto'
        rowClassName={rowClassName}
        style={{
          backgroundColor: '#292929',
          borderRadius: '12px',
          overflowX: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: 'white #1A1A1A',
        }}
      />
    </div>
  );
};

export default FriendInvited;
